<template>
  <v-card>
    <v-card-text>
      <v-container>
        <form ref="form" @submit.prevent="cancelarEnvio()">
          <v-row>
            <v-col>
              <v-card-title class="justify-center">
                <div>Cancelar el envío: {{ item.id }}</div>
              </v-card-title>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                outlined
                label="ID"
                append-icon="mdi-identifier"
                v-model="id"
                readonly
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                outlined
                label="Razón de cancelación"
                append-icon="mdi-text-box-edit-outline"
                v-model="razon_cancelacion"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-btn type="submit" color="teal lighten-2" text
            >Cancelar envío</v-btn
          >
        </form>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "CancelarEnvio",
  props: ["item"],
  data() {
    return {
      id: this.item.id,
      razon_cancelacion: this.item.razon_cancelacion,
      itemsActivo: [
        {
          text: "Cierto",
          value: true,
        },
        {
          text: "Falso",
          value: false,
        },
      ],
      currentPlantilla: "",
    };
  },
  methods: {
    async cancelarEnvio() {
      try {
        const response = await axios.put(
          `/envios/cancelar?id_envio=${this.id}&razon_cancelacion=${this.razon_cancelacion}`,
          {},
          {
            headers: {
              accept: "application/json",
            },
          }
        );
        console.log(JSON.stringify(response.data));
        alert("Envio cancelado");
        this.$emit("envioModificado");
        // location.reload();
      } catch (error) {
        console.error(error); // Handle any errors that might occur
        alert(error);
      }
    },
  },
  computed: {
    ...mapGetters(["perfil"]),
  },
};
</script>
